// The Terms of Use text, bundled at build time from terms.md (wording owned by
// the attorney: never edit it here). TERMS_VERSION comes from its "Version" line.
import md from '../content/terms.md';
import { parseTermsVersion, termsIsDraft } from './terms';

export const TERMS_MD: string = md;
export const TERMS_VERSION: string = parseTermsVersion(md);
export const TERMS_DRAFT: boolean = termsIsDraft(md);
if (!TERMS_VERSION) throw new Error('src/content/terms.md needs a "Version <id>" line');
